module.exports = __webpack_public_path__ + "img/p3i0_en.2a206071.png";